import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

export default function EarningsCallTranscriptListDataGrid({transcript_list} :any) {
  const columns = [
    { field: 'id', headerName: 'Date', width: 200, renderHeader:(params) => ( <strong>Date</strong>) },
    { field: 'name', headerName: 'Transcript', width: 200, renderHeader:(params) => ( <strong>Transcript</strong>), renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={params.getValue(params.id, 'path') }><strong>{params.value}</strong></a>)},
    { field: 'quarter', headerName: 'Quarter', width: 200, renderHeader:(params) => ( <strong>Quarter</strong>) },
    { field: 'year', headerName: 'Year', width: 200, renderHeader:(params) => ( <strong>Year</strong>) },
  ];

  const rows = transcript_list.data;

  return (
    <div className="earnings-transcript-grid">
      <style>{`
        .earnings-transcript-grid {
          width: 100%;
        }

        .earnings-transcript-grid .MuiDataGrid-root {
          border: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .earnings-transcript-grid .MuiDataGrid-columnHeaders {
          background: #f9fafb;
          border-bottom: 1px solid #e5e7eb;
        }

        .earnings-transcript-grid .MuiDataGrid-columnHeader,
        .earnings-transcript-grid .MuiDataGrid-cell {
          border-bottom: 1px solid #f3f4f6;
        }

        .earnings-transcript-grid .MuiDataGrid-cell {
          color: #111827;
        }

        .earnings-transcript-grid .MuiDataGrid-cell:focus,
        .earnings-transcript-grid .MuiDataGrid-columnHeader:focus,
        .earnings-transcript-grid .MuiDataGrid-cell:focus-within,
        .earnings-transcript-grid .MuiDataGrid-columnHeader:focus-within {
          outline: none;
        }

        .earnings-transcript-grid .MuiDataGrid-row:hover {
          background: #f9fafb;
        }

        .earnings-transcript-grid .MuiDataGrid-footerContainer {
          border-top: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .earnings-transcript-grid .MuiTablePagination-root,
        .earnings-transcript-grid .MuiTablePagination-caption,
        .earnings-transcript-grid .MuiTablePagination-selectIcon,
        .earnings-transcript-grid .MuiIconButton-root {
          color: #4b5563;
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-root {
          border-color: #322f2f;
          background: #222328;
          color: #ffffff;
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-columnHeaders {
          background: linear-gradient(to right, #1a191d, #222328);
          border-bottom-color: #322f2f;
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-columnHeader,
        .dark-mode .earnings-transcript-grid .MuiDataGrid-cell {
          border-bottom-color: #322f2f;
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-cell {
          color: #ffffff;
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-row:hover {
          background: rgba(255, 255, 255, 0.03);
        }

        .dark-mode .earnings-transcript-grid .MuiDataGrid-footerContainer {
          border-top-color: #322f2f;
          background: #1a191d;
        }

        .dark-mode .earnings-transcript-grid .MuiTablePagination-root,
        .dark-mode .earnings-transcript-grid .MuiTablePagination-caption,
        .dark-mode .earnings-transcript-grid .MuiTablePagination-selectIcon,
        .dark-mode .earnings-transcript-grid .MuiIconButton-root,
        .dark-mode .earnings-transcript-grid .MuiDataGrid-columnSeparator {
          color: #d8d8d8;
        }

        .dark-mode .earnings-transcript-grid a {
          color: #d9b3ff;
        }
      `}</style>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        autoHeight={true}
        autoPageSize={true}
        density={"compact"}
        disableColumnMenu
      />
    </div>
  );
}
